/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { DebugSendWelcomeEmailOptions, DebugSendWelcomeEmailStatus200, DebugSendWelcomeEmailStatus422 } from '../models/DebugSendWelcomeEmail'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { debugSendWelcomeEmail } from '../clients/axios/debugSendWelcomeEmail'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const debugSendWelcomeEmailMutationKey = () => [{ url: '/admin/debug/send-welcome-email' }] as const

export function debugSendWelcomeEmailMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = debugSendWelcomeEmailMutationKey()
  return mutationOptions<DebugSendWelcomeEmailStatus200, ResponseErrorConfig<DebugSendWelcomeEmailStatus422>, DebugSendWelcomeEmailOptions, TContext>({
    mutationKey,
    mutationFn: async({ body }) => {
      return await debugSendWelcomeEmail({ ...config, body, throwOnError: true })
    },
  })
}

/**
 * @description Queue a welcome email for a given user.
 * @summary Send Welcome Email
 * {@link /admin/debug/send-welcome-email}
 */
export function useDebugSendWelcomeEmail<TContext>(options: {
  mutation?: UseMutationOptions<DebugSendWelcomeEmailStatus200, ResponseErrorConfig<DebugSendWelcomeEmailStatus422>, DebugSendWelcomeEmailOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? debugSendWelcomeEmailMutationKey()

  const baseOptions = debugSendWelcomeEmailMutationOptions(config) as UseMutationOptions<DebugSendWelcomeEmailStatus200, ResponseErrorConfig<DebugSendWelcomeEmailStatus422>, DebugSendWelcomeEmailOptions, TContext>

  return useMutation<DebugSendWelcomeEmailStatus200, ResponseErrorConfig<DebugSendWelcomeEmailStatus422>, DebugSendWelcomeEmailOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<DebugSendWelcomeEmailStatus200, ResponseErrorConfig<DebugSendWelcomeEmailStatus422>, DebugSendWelcomeEmailOptions, TContext>
}
